var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '커뮤니티'
    }
  }), _c('div', {
    staticClass: "tab-list--primary-wrap"
  }, [_c('ul', {
    staticClass: "tab-list tab-list--primary"
  }, [_c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/community/notice"
    }
  }, [_vm._v("공지사항")])], 1), _c('li', {
    staticClass: "on"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/community/reference"
    }
  }, [_vm._v("자료실")])], 1), _c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/community/qna"
    }
  }, [_vm._v("QnA")])], 1)])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "archive",
      "tit": "자료실"
    }
  }), _c('div', {
    staticClass: "board-container"
  }, [!_vm._reference ? _c('board-list', _vm._b({
    attrs: {
      "writeScope": ['console']
    }
  }, 'board-list', _vm.boardProps, false)) : _vm.isWrite ? _c('board-input', _vm._b({}, 'board-input', _vm.boardProps, false)) : _c('board-view', _vm._b({
    attrs: {
      "_id": _vm._reference
    }
  }, 'board-view', _vm.boardProps, false))], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }